import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";

import "./Answer.css";
import usePrevious from "../../shared/usePrevious";
import * as actionTypes from "../../store/actions";

const Answer = (props) => {
  const categoryTickets = props.categoryTickets;
  let prevCurrentCategoryTickets = usePrevious(categoryTickets);

  //handler
  const handler = useCallback(() => {
    if (props.id !== props.rightAnswer) {
      props.wrongAnswerHandler(props.id, true);
    } else props.wrongAnswerHandler(props.id, false);
    props.setClickedAnswerId(props.id);
  }, [props]);

  useEffect(() => {
    //pressed Key check
    if (props.pressedKey === props.id) {
      handler();
    }
  }, [props, handler]);

  //btn click handler
  const onClickedId = () => {
    handler();
  };

  const classHandler = () => {
    if (categoryTickets !== prevCurrentCategoryTickets) {
      return "";
    } else {
      if (
        (props.isError && props.clickedAnswerId !== null) === true &&
        props.id === props.rightAnswer
      )
        return "green ";
      if (
        props.clickedAnswerId === props.rightAnswer &&
        props.clickedAnswerId === props.id
      )
        return "green ";
      if (props.clickedAnswerId === props.id) return "red ";
      else return "";
    }
  };

  /*   console.log("Клик айди " + clickedAnswerId);
  console.log("Ответ не верный? " + props.isError);
  console.log(classHandler()); */

  return (
    <div
      onClick={onClickedId}
      className={
        "answer " +
        (classHandler() === undefined ? "" : classHandler()) +
        (props.isError !== null ? "non-pointer" : "")
      }

    >
      {props.id === props.rightAnswer ? <div itemProp="acceptedAnswer" itemType="http://schema.org/Answer" itemScope>
        <p itemProp="text" className="select-answer">
          <b>{props.answer.slice(0, 2)}</b>
          {props.answer.slice(2, props.answer.length)}
        </p>
      </div>

        : <div itemProp="suggestedAnswer" itemType="http://schema.org/Answer" itemScope>
          <p itemProp="text" className="select-answer">
            <b>{props.answer.slice(0, 2)}</b>
            {props.answer.slice(2, props.answer.length)}
          </p>
        </div>
      }

      {props.isError === true && props.id === props.rightAnswer && (
        <p>{props.hint}</p>
      )}
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    clickedAnswerId: state.ticketsReducer.clickedAnswerId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Answer);
